import Stack from '@mui/material/Stack'
import Tooltip from '@mui/material/Tooltip'
import IconButton from '@mui/material/IconButton'
import PaddedText from './PaddedText'
import ArrowDropUp from '@mui/icons-material/ArrowDropUp'
import { ArrowDropDown } from '@mui/icons-material'
import Button from '@/shared/Button'

const RowHeader = ({ label, onClick, onExpand, height, hasChildren, selected }) => (
  <Stack direction={'row'}>
    <Tooltip title={label} placement="right-start" arrow>
      <Button variant="text" sx={{ flex: 1, height }} onClick={onClick}>
        <Stack direction={'row'} spacing={1} alignItems={'center'} width={'100%'}>
          <PaddedText typographyProps={{ noWrap: true }}>{label}</PaddedText>
        </Stack>
      </Button>
    </Tooltip>

    {hasChildren && (
      <Stack justifyContent="center">
        <IconButton
          size="small"
          onClick={() => {
            onExpand?.()
          }}
        >
          {selected ? <ArrowDropUp /> : <ArrowDropDown />}
        </IconButton>
      </Stack>
    )}
  </Stack>
)

export default RowHeader
